package com.sweetlime.bingeamigo.repository.impl

import com.sweetlime.bingeamigo.model.AppNotification
import com.sweetlime.bingeamigo.repository.AppNotificationsRepository
import dev.gitlive.firebase.firestore.Direction
import dev.gitlive.firebase.firestore.FirebaseFirestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.map

class FirebaseAppNotificationsRepository(
    private val firestore: FirebaseFirestore
) : AppNotificationsRepository {

    private fun collection(userId: String) = firestore
        .collection("users")
        .document(userId)
        .collection("notifications")

    override fun observeNotifications(userId: String): Flow<List<AppNotification>> =
        collection(userId)
            .orderBy("createdAt", Direction.DESCENDING)
            .limit(50)
            .snapshots()
            .map { snapshot ->
                snapshot.documents.mapNotNull { doc ->
                    runCatching { doc.data<AppNotification>().copy(id = doc.id) }.getOrNull()
                }
            }
            .catch { emit(emptyList()) }

    override fun observeUnreadCount(userId: String): Flow<Int> =
        collection(userId)
            .where { "read" equalTo false }
            .snapshots()
            .map { it.documents.size }
            .catch { emit(0) }

    override suspend fun markAsRead(userId: String, notificationId: String) {
        runCatching {
            collection(userId).document(notificationId).update("read" to true)
        }
    }

    override suspend fun markAllAsRead(userId: String) {
        runCatching {
            val unread = collection(userId)
                .where { "read" equalTo false }
                .get()
            unread.documents.forEach { doc ->
                runCatching { doc.reference.update("read" to true) }
            }
        }
    }
}